import { memo } from 'react';
import type { GenericSearchItem } from '../SearchItemsProvider';
import StatusField from '../fields/generic/StatusField';
import SyndicationStatusField from '../fields/syndication/SyndicationStatusField';
import { Typography } from '@mui/material';
import { bloxValues } from 'themes/constants';

type IconAndStatusSwitcherProps = {
  resource?: string;
  record: GenericSearchItem;
};

export const IconAndStatusSwitcher = memo(
  ({ record, resource }: IconAndStatusSwitcherProps) => {
    switch (resource) {
      case 'editorial':
      case 'collections': {
        return <StatusField record={record} />;
      }
      case 'wire/channel/search': {
        return <SyndicationStatusField record={record} />;
      }
      default: {
        const statusTxt = record?.status || null;
        if (statusTxt === null) {
          return null;
        }
        return (
          <Typography
            data-testid="status-text"
            sx={{
              fontSize: bloxValues.smallFontSizeRem,
            }}
          >
            {statusTxt}
          </Typography>
        );
      }
    }
  },
);
IconAndStatusSwitcher.displayName = 'IconAndStatusSwitcher';
